import { ImageOptions, VideoOptions } from './../../shell/Image';
import { ImageSourcePropType, Platform, TextInput } from 'react-native';
import { RootState } from '../store';
import { produce } from 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Question, { Option, Title } from '../../shell/Questions';
import Character, { Properties } from '../../shell/Character';
import UI, { globalUIINT, UIClickableItem, UIINT } from '../../shell/UI';
import { GlobalAnswersINT } from '../../shell/PropertiesDeclarations';
import { GameNames } from './GameTypes';
import { saveObject } from '../../components/menu/SaveLoad';
import Game, { GameVersion } from '../../shell/Game';
import { SoundOptions } from '../../shell/Sound';




export interface TLastUpdate {
    updatedValue: GameNames | null,
    shouldStop?: boolean,
    clear?: boolean;
}
export interface TalkStyleInt {
    overlay?: boolean;

}
export interface TtalkStateINTOptions {
    think?: boolean,
    method?: string,
    wait?: number | boolean,
    style?: TalkStyleInt;
}
export interface TtalkStateINT {
    text: string,
    options?: TtalkStateINTOptions,
    character?: TCharacter,
    hide?: boolean,
}
export interface TextInputINT {
    display?: boolean,
    text: string,
    placeholder: string,
    key: string,

}

export interface TimageINTExtend {
    [key: string]: TimageINT;
}

export interface TuiINT {
    displayUI?: boolean,
    key: keyof globalUIINT,
    btns: UIINT[],
    answers?: globalUIINT,
    value?: string,
}
export interface TClickableItemsINT {
    displayClickableMap?: boolean,
    key: keyof globalUIINT,
    mainImage: TimageINT;
    value?: string | null,
    clickableImages: UIClickableItem[];
}

export interface TCharacters {
    [key: string]: TCharacter;
}
export interface TCharacter {
    properties?: Properties<any>,
    propertiesBackup?: any;
    name: string,
    key: string,
    color?: string,
}

export interface TimageINT {
    url: ImageSourcePropType,
    key?: string,
    parent?: TimageINT,
    type?: GameNames,
    animation?: boolean,
    poster?: TimageINT,
    partials?: TimageINTExtend,
    partial?: boolean,
    main?: ImageSourcePropType,
    options?: ImageOptions & VideoOptions;
    partialsToDisplay?: TimageINT[];
    loopingImages?: TimageINT[];

}
export interface TanimationsINT {
    sources: TimageINT[],
    key: string,
    type: GameNames,
    options?: ImageOptions & VideoOptions,
    isRunning?: boolean;


}

export interface TquestionINT {
    title: Title,
    options: Option[] | null,
    globalAnswers: GlobalAnswersINT,
    displayQuestion: boolean;
    disabled?: boolean;
}
export interface TquestionFormat {
    question: TquestionINT,
    text: string,
    character?: TCharacter;
}


export interface GameObject {
    talk: TtalkStateINT,
    image: TimageINT,
    animations: TanimationsINT,
    question: TquestionINT,
    lastUpdated: GameNames | null,
    textInput: TextInputINT,
    shouldStop: boolean | number | undefined,
    waitInput: boolean,
    characters: TCharacters,
    ui: TuiINT,
    clickableMap: TClickableItemsINT;
    currentScene: string,
    seenScenarios: string[],
    index: number,
    version: string,

}

export const gameObjectInitial: GameObject = {
    talk: {
        text: "",
    } as TtalkStateINT,
    image: {
        url: '',
        key: '',
        type: GameNames.IMAGE,
        partial: false,
        partialsToDisplay: []


    } as TimageINT,
    animations: {
        sources: [],
        key: '',
        type: GameNames.ANIMATION,
        isRunning: false,
    },
    question: {
        displayQuestion: false,
        title: {

        },
        options: null,
        globalAnswers: {},

    } as TquestionINT,
    textInput: {
        display: false,
        text: ''
    } as TextInputINT,
    ui: {
        answers: {},
    } as TuiINT,
    clickableMap: {
    } as TClickableItemsINT,

    characters: {

    } as TCharacters,
    index: 0,
    currentScene: "start",
    lastUpdated: GameNames.INIT,
    shouldStop: false,
    waitInput: false,
    version: ``,
    seenScenarios: ["start"],
};

const gameObjectSlice = createSlice({
    name: "gameObject",
    initialState: gameObjectInitial,
    reducers: {
        setImage(state, { payload }: PayloadAction<TimageINT>) {
            return produce(state, draft => {
                // draft.image = { ...draft.image, ...payload };
                if (payload.partial) {
                    if (!draft.image.partialsToDisplay || payload.options?.putParent) {


                        if (payload.options?.putParent && payload.parent) {
                            const copyPayload = JSON.parse(JSON.stringify(payload));
                            draft.image = copyPayload.parent;
                            draft.image.partialsToDisplay = [copyPayload];
                        } else {

                            draft.image.partialsToDisplay = [];
                        }

                    }
                    const imageExists = draft.image.partialsToDisplay.findIndex(_image => _image.key == payload.key);

                    if (imageExists > -1) {
                        draft.image.partialsToDisplay.splice(imageExists, 1);
                        draft.image.partialsToDisplay.push(payload);
                    } else {
                        draft.image.partialsToDisplay.push(payload);
                    }
                    draft.lastUpdated = GameNames.IMAGE_PAR;
                } else {

                    draft.image = payload;
                    draft.lastUpdated = GameNames.IMAGE;
                }
                if (payload.options?.hideText) {
                    draft.talk.hide = true;
                    // draft.talk.character = undefined;
                }
                if (draft.animations?.sources) {
                    draft.animations.sources.length = 0;
                } else {


                }
                if (draft.animations) {

                    if (draft.animations.isRunning) {
                        if (draft.image.options) {
                            // draft.image.options.duration = 0;

                        } else {
                            // draft.image.options = { duration: 0 };
                        }

                    }

                    draft.animations.isRunning = false;
                }
                draft.index = draft.index + 1;
                draft.shouldStop = payload.options?.wait;
            });
        },
        setAnimations(state, { payload }: PayloadAction<TanimationsINT>) {
            return produce(state, draft => {
                if (payload.options?.hideText) {
                    draft.talk.text = '';
                    draft.talk.character = undefined;
                }
                draft.animations = { ...draft.animations, ...payload };
                draft.shouldStop = payload.options?.wait;
                if (draft.animations.isRunning) {
                    draft.animations.sources[0].options = { ...draft.animations.sources[0].options, duration: 0 };
                }
                draft.index = draft.index + 1;
                draft.animations.isRunning = true;
                draft.lastUpdated = GameNames.ANIMATION;
            });
        },
        setQuestion(state, { payload }: PayloadAction<TquestionFormat>) {
            // payload.status = true;
            return produce(state, draft => {

                const { question, ...talk } = payload;
                draft.question = { ...draft.question, ...question };
                // draft.talk = talk;
                if (question.title.options?.array && draft.question.globalAnswers[question.title.options.array] == null) {
                    draft.question.globalAnswers = { ...draft.question.globalAnswers, [question.title.options.array]: [] };
                }
                draft.talk = { ...draft.talk, ...talk, options: { ...payload.question.title.options, style: draft.talk.options?.style } };
                draft.lastUpdated = GameNames.QUESTION;
                draft.index = draft.index + 1;
                draft.shouldStop = true;
                draft.waitInput = true;
                draft.talk.hide = false;
            });
        },
        setQuestionAnswer(state, { payload }: PayloadAction<Option & { titleKey: string; }>) {
            // payload.status = true;
            return produce(state, draft => {

                // draft.question.globalAnswers = { ...draft.question.globalAnswers, [draft.question.title.key]: payload.key };
                // draft.question.globalAnswers = JSON.parse(JSON.stringify(Question.globalAnswers))
                // draft.question.globalAnswers = { ...draft.question.globalAnswers, [draft.question.title.key]: payload.key };

                const question = { ...draft.question.globalAnswers };
                const array = draft.question.title.options?.array;
                if (array) {
                    if (!question[array]) {
                        (question[array] as any) = [payload.key];
                    } else {

                        ((question[array] as []).push as any)(payload.key);
                    }
                }

                // draft.question.globalAnswers = question;
                draft.question.globalAnswers = { ...question, [payload.titleKey]: payload.key };
                draft.question.displayQuestion = false;
                // draft.question.title = { key: null as any, text: '' };
                draft.lastUpdated = GameNames.QUESTION;
                draft.shouldStop = false;
                draft.waitInput = false;
            });
        },
        // setQuestionStatus(state, { payload }: PayloadAction<boolean>) {
        //     state.question.stopAdvance = payload;
        // },
        setTtalk: (state, { payload }: PayloadAction<TtalkStateINT>) => {
            return produce(state, draft => {
                // draft.talk = payload;
                draft.talk = { ...payload, options: { ...payload.options, style: payload.options?.style || draft.talk.options?.style } };
                draft.lastUpdated = GameNames.TALK;

                draft.shouldStop = payload.options?.wait != null ? !!payload.options?.wait : true;
                draft.index = draft.index + 1;
                draft.waitInput = false;
                draft.talk.hide = false;
            });
        },
        setInputText: (state, { payload }: PayloadAction<Partial<TextInputINT>>) => {
            return produce(state, draft => {
                draft.textInput = { ...draft.textInput, ...payload };
                if (payload.display) {
                    // draft.talk.text = "";
                    // draft.talk.character = undefined;

                    draft.talk.hide = true;
                    draft.textInput.text = payload.text || '';
                    draft.shouldStop = true;
                    draft.waitInput = true;
                    draft.lastUpdated = GameNames.INPUT;

                } else {
                    draft.shouldStop = false;
                    draft.waitInput = false;
                    draft.lastUpdated = GameNames.INPUT;
                }
                draft.index = draft.index + 1;
            });
        },
        setUI: (state, { payload }: PayloadAction<TuiINT>) => {
            return produce(state, draft => {
                draft.ui = { ...draft.ui, ...payload };

                if (payload.displayUI) {
                    draft.talk.text = "";
                    draft.talk.character = undefined;
                    draft.shouldStop = true;
                    draft.waitInput = true;
                } else {
                    draft.ui.answers = { ...payload.answers, [payload.key.toString()]: payload.value } as any;
                    // I removed it because it causes a bug that if you scroll back to UI after continue and hit insta (for example) it stalls
                    // draft.ui.key = null as any;
                    draft.shouldStop = false;
                    draft.waitInput = false;

                }
                draft.lastUpdated = GameNames.UI;

                draft.index = draft.index + 1;
            });
        },
        setClickableMap: (state, { payload }: PayloadAction<TClickableItemsINT>) => {
            return produce(state, draft => {
                draft.clickableMap = { ...draft.clickableMap, ...payload };

                if (payload.displayClickableMap) {
                    draft.image = payload.mainImage;
                    draft.talk.text = "";
                    draft.talk.character = undefined;
                    draft.shouldStop = true;
                    draft.waitInput = true;
                } else {
                    draft.ui.answers = { [payload.key.toString()]: payload.value } as any;
                    draft.shouldStop = false;
                    draft.waitInput = false;

                }
                draft.lastUpdated = GameNames.UI;

                draft.index = draft.index + 1;
            });
        },
        setCharacter: (state, { payload }: PayloadAction<TCharacter & { shouldStop?: boolean; }>) => {
            return produce(state, draft => {
                // TODO: throw error in production if one of the values of properties are nan - and write to file if in prod
                // if(draft.characters[payload])
                // const payload2 = payload;
                if (!draft.characters[payload.key]) {
                    draft.characters[payload.key] = payload;
                } else {
                    draft.characters[payload.key] = {
                        ...draft.characters[payload.key], ...payload, properties: { ...draft.characters[payload.key].properties, ...payload.properties }
                    };
                }


                draft.shouldStop = !!payload.shouldStop;
                draft.waitInput = false;
                draft.index = draft.index + 1;
                draft.lastUpdated = GameNames.CHARACTERS;
            });
        },
        getCharacter: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                // if(draft.characters[payload])
                // const payload2 = payload;
                // draft.characters = { ...draft.characters, ...payload };

                draft.lastUpdated = GameNames.CHARACTERS;
            });
        },
        setCurrentScene: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                if (!draft.seenScenarios.includes(draft.currentScene)) {
                    draft.seenScenarios.push(draft.currentScene);
                }
                draft.currentScene = payload;
                draft.shouldStop = false;
                draft.waitInput = false;
                draft.index = 0;
                draft.lastUpdated = GameNames.JUMP;
            });
        },
        setLastUpdated: (state, { payload }: PayloadAction<TLastUpdate>) => {
            return produce(state, draft => {
                if (payload?.clear) {
                    draft.talk = { text: '', };
                }
                draft.lastUpdated = payload?.updatedValue;
                if (payload.shouldStop != undefined) {
                    draft.shouldStop = payload.shouldStop;
                }
                if (payload?.updatedValue == null) {
                    draft.shouldStop = false;
                }
                draft.index = draft.index + 1;
                // draft.lastUpdated = GameNames.LAST_UPDATED;
            });
        },
        setGlobalQuestions: (state, { payload }: PayloadAction<GlobalAnswersINT>) => {
            return produce(state, draft => {
                draft.question.globalAnswers = payload;
            });
        },
        // setCharacterProperties: (state, { payload }: PayloadAction<TCharacter>) => {
        //     setCharacter(payload);
        //     // return produce(state, draft => {
        //     //     draft.characters = payload;
        //     // });
        // },
        endReplay: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                // if (!draft.seenScenarios.includes(draft.currentScene)) {
                //     draft.seenScenarios.push(draft.currentScene);
                // }
                // draft.currentScene = payload;
                // draft.shouldStop = false;
                // draft.waitInput = false;
                draft.index = draft.index + 1;
                draft.lastUpdated = GameNames.END_REPLAY;
                draft.shouldStop = false;
                draft.waitInput = false;
            });
        },
        setVersion: (state, { payload }: PayloadAction<GameVersion>) => {
            return produce(state, draft => {
                draft.version = payload;
            });
        },
        resetIndex: (state) => {
            return produce(state, draft => {
                draft.index = 0;
            });
        },
        resetGameObject: state => gameObjectInitial,
        setGameObject: (state, { payload }: PayloadAction<GameObject>) => payload,
    }
});

export const selectTtalk = (state: RootState) => state.gameObject.present.talk;
export const selectTtalkStyle = (state: RootState) => state.gameObject.present.talk.options?.style;
export const selectTImage = (state: RootState) => state.gameObject.present.image;
export const selectAnimations = (state: RootState) => state.gameObject.present.animations;
export const selectKQuestion = (state: RootState) => state.gameObject.present.question;
export const selectGameObject = (state: RootState) => state.gameObject;
export const selectTextInput = (state: RootState) => state.gameObject.present.textInput;
export const selectUi = (state: RootState) => state.gameObject.present.ui;
export const selectClickableMap = (state: RootState) => state.gameObject.present.clickableMap;

export const { setImage,
    setQuestion,
    setTtalk,
    resetGameObject,
    setQuestionAnswer,
    setInputText,
    setUI,
    setClickableMap,
    setCharacter,
    setCurrentScene,
    setLastUpdated,
    setGameObject,
    setAnimations,
    setGlobalQuestions,
    setVersion,
    resetIndex,
} = gameObjectSlice.actions;
export default gameObjectSlice.reducer;

